import React from "react";

import styled from "styled-components";
import categoryIcon1 from "../assets/image/category1.png";
import categoryIcon2 from "../assets/image/category2.png";
import categoryIcon3 from "../assets/image/category3.png";
import categoryIcon4 from "../assets/image/category4.png";

export default function SupportDiv() {
  const categoryArr = [
    { icon: categoryIcon1, title: "제품 설계" },
    { icon: categoryIcon2, title: "장비 납품" },
    { icon: categoryIcon3, title: "교육 운영" },
    { icon: categoryIcon4, title: "서비스 지원" },
  ];

  const SupportDiv = styled.div`
    height: 180px;
    width: 100%;

    display: flex;
    flex-direction: row;
  `;

  const Info = styled.div`
    height: 100%;
    width: 34%;
    background-color: #eeedef;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;

    & > div {
      display: flex;
      flex-direction: row;
      gap: 12px;

      align-items: baseline;
    }

    & > div:first-child {
      font-size: 36px;
      font-weight: bold;
      color: var(--color-blue);
    }

    & > div:nth-child(2) > div:first-child {
      font-size: 18px;
      font-weight: bold;
    }

    & > div:nth-child(2) > div:nth-child(2) {
      font-size: 12px;
      color: var(--color-darkgrey);
    }
  `;

  const Category = styled.div`
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  `;

  const CategoryItem = styled.div`
    height: 100%;
    width: 25%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > div {
      text-align: center;
      font-size: 18px;
    }
  `;

  return (
    <SupportDiv>
      <Info>
        <div>062-571-0401</div>
        <div>
          <div>평일 09:00~18:00</div>
          <div>(토•일•공휴일 제외)</div>
        </div>
      </Info>
      <Category>
        {categoryArr.map((category, index) => {
          return (
            <CategoryItem key={index}>
              <img src={category.icon} alt={`category${index + 1}.png`} />
              <div>{category.title}</div>
            </CategoryItem>
          );
        })}
      </Category>
    </SupportDiv>
  );
}
